<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar v-if="nivel==1" title="Receitas/Despesas" :subtitle="tituloRegime" 
                exibeVoltar="true" historyback="false" 
                @navigate="navigate" navigateto="regime"/>

            <top-bar v-if="nivel==4" title="Receitas/Despesas" :subtitle="tituloRegime" 
                exibeVoltar="true" historyback="false" navigateto="regime" @navigate="carregaNivel1" />      
        </div>
		<div class="app-centro-sem-rodape">
            <div v-if="nivel==1">
                <barra-navegacao @proximo="proximo" @anterior="anterior">
                    <span class="navegacao"><center>{{ titulo }}</center></span>
                </barra-navegacao>
                <div class="receitas-despesas">
                    <table class="table">
                        <tr>
                            <td width="30%" class="label">Receitas:</td>
                            <td align="right"><span-valor :valor="receitas[0].Valor"/></td>
                        </tr>
                        <tr>
                            <td class="label">Despesas:</td>
                            <td align="right"><span-valor :valor="despesas[0].Valor"/></td>
                        </tr>
                        <tr>
                            <td class="label">Total:</td>
                            <td align="right"><span-valor :valor="receitas[0].Valor-despesas[0].Valor"/></td>
                        </tr>
                    </table>
                    <center>
                        <div @click="detalhar"  class="detalhar" ><button>Detalhar</button></div>
                    </center>
                </div>
                <div>
                    
                </div>
            </div>

            <div class="div-detalhamento" v-if="nivel==4">
                <br/>
                <table  class="table"> 
                    <tr>
                        
                        <th align="center" colspan="3">Receitas {{titulo}}</th>
                        
                    </tr>
                    <tr>
                        <th width="20%">Código</th>
                        <th>Descrição</th>
                        <th width="25%">Valor</th>
                    </tr>
                    <tbody  v-for="item in receitas" v-bind:key="item.Cod">
                        <tr>
                            <td>{{item.Cod}}</td>
                            <td>{{item.Desc}}</td>
                            <td><span-valor :valor="item.Valor"/></td>
                        </tr>
                    </tbody>

                    <tr>
                        <td colspan="2" align="right" class="td-total"><b>Total Receitas:</b></td>
                        <td><span-valor :valor="totalReceitas"/></td>
                    </tr>
                    <tr>
                        <td colspan="3"><br/></td>
                    </tr>
                    <tr>
                        
                        <th align="center" colspan="3">Despesas {{titulo}}</th>
                        
                    </tr>
                    <tr>
                        <th>Código</th>
                        <th>Descrição</th>
                        <th>Valor</th>
                    </tr>

                    <tbody  v-for="item in despesas" v-bind:key="item.Cod">
                        <tr>
                            <td>{{item.Cod}}</td>
                            <td>{{item.Desc}}</td>
                            <td><span-valor :valor="item.Valor"/></td>
                        </tr>
                    </tbody>

                    <tr>
                        <td colspan="2" align="right" class="td-total"><b>Total Despesas:</b></td>
                        <td><span-valor :valor="totalDespesas"/></td>
                    </tr> 
                    <tr>
                        <td colspan="3"><br/></td>
                    </tr>

                    <tr>
                        <td colspan="2" align="right" class="td-total"><b>Saldo (Receitas-Despesas):</b></td>
                        <td><span-valor :valor="totalReceitas-totalDespesas"/></td>
                    </tr>

                </table>
            </div>      
        </div>
	</div>


</template>


<script>

import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';
import {nomedomes} from '@/services/dateutils.js';
import SpanValor from '@/components/shared/SpanValor.vue';
import BarraNavegacao from '@/components/shared/BarraNavegacao.vue';


export default {
    name: 'ReceitasDespesasResultado',
    props: ["regime", "mes", "ano", "detalhamento"],
    components: {TopBar, SpanValor, BarraNavegacao},

    data() {
        return {
            data : new Date(),
            titulo : '',
            receitas : [{Valor : 0}],
            despesas : [{Valor : 0}],
            nivel : 1
        };        
    },

    created(){
        this.data = new Date(this.ano, this.mes-1, 1);
        this. atualizaData(0);
    },

    mounted (){
        this.nivel = this.detalhamento;        
        this.carregarDados(this.detalhamento);
    }, 
    methods : {
        carregarDados(){

            request(this, 'GET',
            'Mobile_Rec_Desp',
            `mes=${this.data.getMonth()+1}&ano=${this.data.getFullYear()}&regime=${this.regime}&NivelDetalhamento1234=${this.nivel}`)
                .then(res => {
                    if(res){

                        if(res.RECEITAS.length){
                            this.receitas = res.RECEITAS;
                        } else {
                            this.receitas = [{Valor : 0}];
                        }

                        if(res.DESPESAS.length){
                            this.despesas = res.DESPESAS;
                        } else {
                            this.despesas = [{Valor : 0}];
                        }

                    }
                });

        },
        atualizaData(mesAdd){

            this.data.setMonth(this.data.getMonth()+mesAdd);      
            var mes = nomedomes(this.data.getMonth());
            this.titulo = `${mes}/${this.data.getFullYear()}`;
      

        }, 
        proximo(){

            this.receitas = [{Valor : 0}];
            this.despesas = [{Valor : 0}];

            this.atualizaData(1);
            this.nivel = 1;

            this.$router.push(`/detalharreceitasdespesas/${this.regime}/${this.mes+1}/${this.ano}/1`);            
            this.carregarDados();            
        },
        anterior(){

            this.receitas = [{Valor : 0}];
            this.despesas = [{Valor : 0}];

            this.atualizaData(-1);
            this.nivel = 1;

            this.$router.push(`/detalharreceitasdespesas/${this.regime}/${this.mes-1}/${this.ano}/1`);
            this.carregarDados();
        },
        detalhar(){

            this.receitas = [{Valor : 0}];
            this.despesas = [{Valor : 0}];

            this.nivel = 4;
            this.$router.push(`/detalharreceitasdespesas/${this.regime}/${this.mes}/${this.ano}/4`);
            this.carregarDados();
        },
        navigate(){
            this.$router.push(`/receitasdespesas/${this.regime}`);
        },
        carregaNivel1(){

            this.receitas = [{Valor : 0}];
            this.despesas = [{Valor : 0}];

            this.nivel = 1;
            this.$router.push(`/detalharreceitasdespesas/${this.regime}/${this.mes-1}/${this.ano}/1`);
            this.carregarDados();            
        }

    },
    
    computed : {
        tituloRegime: function() {
            if(this.regime=='caixa'){
                return `Regime de caixa`;
            } else {
                return `Regime de competência`
            }
        },        
        totalReceitas: function() {
            if(this.receitas.length){
                return this.receitas.reduce((sum, item) => sum + item.Valor, 0);
            } else {
                return 0;
            }
        },
        totalDespesas: function() {
            if(this.despesas.length){
                return this.despesas.reduce((sum, item) => sum + item.Valor, 0);
            } else {
                return 0;
            }
        }
    }
    
}
</script>


<style scoped>
    .table{
        border-collapse: collapse;
        width: calc(100% - 20px);
        margin: 20px 10px;    
        border: 1px solid var(--dark-color);    
    }

    td{
        --border-collapse: collapse;
        border: 1px solid var(--dark-color);
        padding: 5px;
        height: 40px;
    }

    .td-total {
        --background-color: var(--light-color);
        height: 40px;
    }

    th{
        

        border: 1px solid var(--dark-color);
        background-color: var(--primary-color);
        color: white;
        height: 40px;

    }

    .label{
        height: 40px;
        background-color: var(--primary-color);
        color: white;

    }

    .navegacao{
        color: white;
        font-size: 18px;
        line-height: 50px;
    }

    .receitas-despesas{
        height: calc(100vh - 210px);
        overflow: auto;
    }

    .div-detalhamento{
        height: calc(100vh - 70px);
        overflow: auto;
    }

    .detalhar{
        width: 50%;
        float: center;
        text-align: center;
    }

    .detalhar button{
        background-color: var(--primary-color);
        color: white;
        border: 0px;
        height: 44px;
        margin: 10px auto;
        width: 100%;
        border-radius: 10px;
    }

</style>